import { all, fork } from 'redux-saga/effects'

import account from './Account/sagas'

const settingsSaga = function* () {
  yield all([account].map(fork))
}

export default settingsSaga
